import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { type AppointmentOpenDockFormValues, ShipmentRepository } from '../infra/ShipmentRepository'

export type UpdateOpenDockAppointmentParams = {
  shipmentUUID: string
  stopIndex: number
  data: AppointmentOpenDockFormValues
}

export type UpdateOpenDockAppointmentFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function updateOpenDockAppointmentFactory({
  shipmentRepository,
}: UpdateOpenDockAppointmentFactoryDependencies) {
  return async function submit(
    params: UpdateOpenDockAppointmentParams,
    config?: { signal?: AbortSignal }
  ) {
    const { shipmentUUID, stopIndex, data } = params
    try {
      return await shipmentRepository.updateOpenDockAppointment({
        shipmentUUID,
        stopIndex,
        data,
        config,
      })
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not update appointment', { cause: error as Error })
    }
  }
}

export function updateOpenDockAppointment(
  params: UpdateOpenDockAppointmentParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = updateOpenDockAppointmentFactory({ shipmentRepository })

  return submit(params, config)
}
